import { render, staticRenderFns } from "./AdvanceIncomeTable.vue?vue&type=template&id=10f4b5d9&"
import script from "./AdvanceIncomeTable.vue?vue&type=script&lang=js&"
export * from "./AdvanceIncomeTable.vue?vue&type=script&lang=js&"
import style0 from "./AdvanceIncomeTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports